<template>
  <div v-if="showComponent" class="authentication-component">
    <!--START: Vue Headful-->
    <vue-headful :title="meta.title" />
    <!--END: Vue Headful-->

    <div class="authentication-wrapper">
      <!-- Intro -->
      <div class="intro-wrapper">
        <img src="@/assets/images/logo.png" class="logo" alt="Macha Logo" />
        <h1>AI Apps for your Zendesk</h1>
        <p>Access your account</p>
      </div>

      <!-- Apps -->
      <div class="apps-list">
        <div v-for="app in apps" :key="app.key" class="app">
          <img :src="getAppIcon(app.appIcon)" :alt="app.title" />
          <span class="title">{{ app.title }}</span>
        </div>
      </div>

      <!-- Button -->
      <a type="submit" class="btn btn-primary" href="/sign-in" target="_blank">
        <span>Sign into Account</span>
        <unicon name="angle-right-b"></unicon>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  data() {
    return {
      showComponent: false,
      meta: {
        title: "Welcome",
      },
      status: {
        show: false,
        status: null,
        message: null,
      },
      apps: [
        {
          key: "ticketTranslations",
          title: "Ticket Translations AI",
          route: "translations",
          zendeskAppId: "1166071",
          appIcon: "ticket-translations.png",
          hasDownloaded: false,
          app: {},
        },
      ],
    };
  },
  watch: {
    $route(to) {
      if (to.name === "Welcome") {
        this.showComponent = false;
        this.status.show = false;
        this.showLoader = false;

        this.initRoute();
      }
    },
  },
  components: {},
  async created() {
    await this.initRoute();
  },
  methods: {
    async initRoute() {
      if (await this.authenticateUser()) {
        this.redirectDashboard();
      } else {
        this.showComponent = true;
      }
    },

    // Get app icon
    getAppIcon(icon) {
      let iconURL = `/assets/images/apps/${icon}`;
      return iconURL;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";
@import "@/assets/styles/shared/authentication.scss";

.authentication-wrapper {
  width: auto;
  margin-top: -3rem;
}

.apps-list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 3rem;
  margin: 4rem auto 0;

  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  max-width: 60vw;
  margin: 4rem auto 0;
}

.app {
  text-align: center;

  img {
    display: block;
    width: 5rem;
    margin: 0 auto 0.5rem;
    border-radius: 0.85rem;
    border: 1px solid #ececec;
    transform: translateY(0);
    transition: all 0.3s;
  }

  .title {
    font-size: $smallerFontSize;
    font-weight: $mediumFontWeight;
  }

  .btn {
    opacity: 0;
    margin: auto;
    padding: 5px;
    white-space: nowrap;
    margin-top: 2rem;
    justify-content: center;
    width: fit-content;
    padding-right: 0.75rem;
  }

  .downloaded {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    justify-content: center;
    border-radius: 0.5rem;
    margin: auto;
    padding: 0.15rem 0.5rem;
    gap: 0.15rem;

    margin-top: 0.25rem;

    .unicon ::v-deep svg {
      width: 1rem;
      height: auto;
      fill: lighten($greyColor, 15%);
      transform: translateY(1px);
    }

    span {
      font-size: $smallestFontSize;
      font-weight: $mediumFontWeight;
    }

    &.green {
      background-color: lighten($tagGreenBackgroundColor, 5%);

      .unicon ::v-deep svg {
        fill: darken($greenColor, 20%);
      }
    }
  }
}

.btn {
  display: table;
  width: auto;
  margin: 3rem auto 0;
}
</style>
